import { ChatRoomMessage, NotificationMessage, InputModes } from '../types';

export enum ModalTypes {
  MUTE = 'mute',
  REPORT = 'report',
  DELETE = 'delete',
};

export interface ReducerState {
  limit: number;
  token: { next?: string; prev?: string; };
  anchorMessage?: NotificationMessage | undefined;
  messages: (ChatRoomMessage | NotificationMessage)[];
  modalData?: {
    type: ModalTypes,
    data?: any,
  } | undefined;
  inputMode: { type: InputModes; isOpen?: boolean };
  gifUrl: string | null;
  editingMessage: ChatRoomMessage['id'] | null;
}

export interface Action {
  type:
  'SET_LIMIT'
  | 'RESET_LIMIT'
  | 'SET_NEXT_TOKEN'
  | 'SET_PREV_TOKEN'
  | 'RESET_TOKEN'
  | 'SET_ANCHOR_MESSAGE'
  | 'DELETE_ANCHOR_MESSAGE'
  | 'SET_MESSAGES'
  | 'DELETE_ANCHOR_FROM_MESSAGES'
  | 'ADD_MESSAGE'
  | 'DELETE_MESSAGE'
  | 'DELETE_MESSAGES'
  | 'UPDATE_MESSAGE'
  | 'SET_MODAL_DATA'
  | 'DELETE_MODAL_DATA'
  | 'SET_INPUT_MODE'
  | 'SET_GIF_URL'
  | 'DELETE_GIF_URL'
  | 'SET_EDITING_MESSAGE'
  | 'DELETE_EDITING_MESSAGE';
  payload?: any;
}

export const reducer = (state: ReducerState, action: Action): ReducerState => {
  switch (action.type) {
    case 'SET_LIMIT':
      return { ...state, limit: action.payload };
    case 'RESET_LIMIT':
      return { ...state, limit: 0 };
    case 'SET_NEXT_TOKEN':
      return { ...state, token: { ...state.token, next: action.payload } };
    case 'SET_PREV_TOKEN':
      return { ...state, token: { ...state.token, prev: action.payload } };
    case 'RESET_TOKEN':
      return { ...state, token: {} };
    case 'SET_ANCHOR_MESSAGE':
      return { ...state, anchorMessage: action.payload };
    case 'DELETE_ANCHOR_MESSAGE':
      return { ...state, anchorMessage: undefined };
    case 'SET_MESSAGES':
      return { ...state, messages: typeof action.payload === 'function' ? action.payload(state.messages) : action.payload };
    case 'ADD_MESSAGE':
      return { ...state, messages: [...state.messages, action.payload] };
    case 'DELETE_MESSAGES':
      return { ...state, messages: [] };
    case 'DELETE_MESSAGE':
      return { ...state, messages: state.messages.filter(({ id }) => id !== action.payload) };
    case 'UPDATE_MESSAGE':
      const messageIndex = state.messages.findIndex(({ id }) => id === action.payload.id);
      const newMessages = [...state.messages];
      newMessages[messageIndex] = action.payload;

      return { ...state, messages: newMessages };
    case 'DELETE_ANCHOR_FROM_MESSAGES': {
      return { ...state, messages: state.messages.filter(({ id }) => id !== state.anchorMessage?.id) };
    }
    case 'SET_MODAL_DATA': {
      return { ...state, modalData: action.payload };
    }
    case 'DELETE_MODAL_DATA': {
      return { ...state, modalData: undefined };
    }
    case 'SET_INPUT_MODE': {
      return { ...state, inputMode: typeof action.payload === 'function' ? action.payload(state.inputMode) : action.payload };
    }
    case 'SET_GIF_URL': {
      return { ...state, gifUrl: action.payload };
    }
    case 'DELETE_GIF_URL': {
      return { ...state, gifUrl: null };
    }
    case 'SET_EDITING_MESSAGE': {
      return { ...state, editingMessage: action.payload };
    }
    case 'DELETE_EDITING_MESSAGE': {
      return { ...state, editingMessage: null };
    }
    default:
      return state;
  }
};

const wrappedReducer = (state: ReducerState, action: Action | Action[]): ReducerState => {
  if (Array.isArray(action)) {
    let finalState = state;
    action.forEach((a) => {
      finalState = reducer(finalState, a);
    });
    return finalState;
  }

  return reducer(state, action);
};

export default wrappedReducer;
